import axios from 'axios'

const URL_PATH = 'api/pedido'

class RevisoesPedidoUtilizacaoApiClient {
	async buscarRevisoesDisponivel(idPedido) {
		return await axios.get(`${URL_PATH}/revisoes/disponivel?idPedido=${idPedido}`)
	}

	async criarRevisaoPedidoUtilizacao(idPedido, body) {
		await axios.post(`${URL_PATH}/${idPedido}/revisoes`, body)
	}
}

export default new RevisoesPedidoUtilizacaoApiClient()
